import { IgnoredWarningIcon } from './IgnoredWarningIcon';
import { WarningIcon } from './WarningIcon';

export function IgnorableWarningIcon({ ignored, className }: { ignored: boolean; className?: string }) {
    return ignored ? <IgnoredWarningIcon className={className} /> : <WarningIcon className={className} />;
}
